import { render, staticRenderFns } from "./task-row.vue?vue&type=template&id=354d7a8a&"
import script from "./task-row.vue?vue&type=script&lang=js&"
export * from "./task-row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports